import LogisticsClusterPage from './LogisticsClusterPage';

export default function B2BFulfillment() {
  return <LogisticsClusterPage clusterId="b2b" />;
}
